import { useEffect, useRef, useState } from 'react';

const MODAL_CLOSE_MS = 300;

const useRetainedValue = (value, { releaseAfterMs } = {}) => {
  const retainedRef = useRef(value ?? null);
  const [released, setReleased] = useState(false);

  if (value) retainedRef.current = value;

  useEffect(() => {
    if (value) {
      setReleased(false);
      return;
    }

    if (releaseAfterMs === undefined) return;

    const timer = setTimeout(() => setReleased(true), releaseAfterMs ?? MODAL_CLOSE_MS);
    return () => clearTimeout(timer);
  }, [value, releaseAfterMs]);

  if (value) return value;
  return released ? null : retainedRef.current;
};

export default useRetainedValue;
